import React from 'react'
import './backDrop.scss'

const BackDrop =(props)=> {
    return (
        <div className="backdrop" onClick = {props.toggleSidebar}/>
    )
}
export default  BackDrop